var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nav vue-title",
      attrs: { id: "page_title", mode: _vm.activeMode }
    },
    [
      _c(
        "p",
        { staticClass: "vue-title__text", attrs: { "data-testid": "title" } },
        [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")]
      ),
      _c("i", {
        staticClass: "btn icon icon--small icon-lock",
        attrs: { id: "lockIcon" }
      }),
      _c("VueVersionSwitch", {
        attrs: {
          version: _vm.pageVersion,
          setPageVersion: _vm.setPageVersion,
          popoverOptions: _vm.popoverOptions
        },
        on: {
          startChange: _vm.onVersionChangeStart,
          change: _vm.onVersionChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }